const protectionContent = `<html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
.privacyContent {
  font-size: 10.5pt !important;
}
</style>

</head>

<body lang=ZH-CN link=blue vlink="#7E1FAD" style='word-wrap:break-word;
text-justify-trim:punctuation'>

<div class=privacyContent>

<p class=MsoNormal><span>更新日期：2023年 12月21日</span></p>

<p class=MsoNormal><span>生效日期：2023年 12月21日</span></p>

<p class=MsoNormal align=center style='text-align:center'><b><span lang=EN-US
style='font-family:"Times New Roman",serif;color:black;background:white'>&nbsp;</span></b></p>

<p class=MsoNormal><b><span style='font-size:12.0pt;color:black;
background:#EEEEEE'>一、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;color:black;background:#EEEEEE'>概要</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span>上海蛮啾网络科技有限公司及其关联公司（以下统称“<b>蛮啾</b>”或“<b>我们</b>”）致力于保护使用我们产品或服务的<b>儿童（指未满</b></span><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>14</span></b><b><span
>周岁的未成年人，下同）</span></b><span>的个人信息和隐私安全。本《蛮啾儿童隐私保护规则及监护人须知》（以下简称</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>“</span><b><span
>本规则</span></b><span lang=EN-US style='font-family:"Times New Roman",serif'>”</span><span
>）旨在向儿童、儿童的父母或其他监护人（以下统称</span><span lang=EN-US
style='font-family:"Times New Roman",serif'>“</span><b><span style='font-family:
宋体'>监护人</span></b><span lang=EN-US style='font-family:"Times New Roman",serif'>”</span><span
>）说明我们如何收集、使用、存储和处理儿童的个人信息时对应的处理规则相关事宜。本隐私政策为</span><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/userAgreement" target="_blank" ><span lang=EN-US style='font-family:
宋体'><span lang=EN-US>《蛮啾用户许可及服务协议》</span></span></a></span><span
>及</span><span lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/privacy" target="_blank" ><span lang=EN-US><span
lang=EN-US>《蛮啾隐私政策》</span></span></a></span><span>不可分割的一部分，除另有约定外，本隐私政策所用术语与</span><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/userAgreement" target="_blank"  ><span lang=EN-US ><span lang=EN-US>《蛮啾用户许可及服务协议》</span></span></a></span><span
>及</span><span lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/privacy" target="_blank" ><span lang=EN-US><span
lang=EN-US>《蛮啾隐私政策》</span></span></a></span><span>相同。在儿童个人信息保护规则方面，本规则与</span><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/privacy" target="_blank" ><span lang=EN-US><span
lang=EN-US>《蛮啾隐私政策》</span></span></a></span><span>正文存在不一致的，本规则优先适用，如本规则中未提及的，则以</span><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/privacy" target="_blank" ><span lang=EN-US><span
lang=EN-US>《蛮啾隐私政策》</span></span></a></span><span>为准。<b>本规则仅适用于能识别用户年龄的产品或服务，针对不能识别或不能主动识别用户年龄的产品或服务，仅适用《蛮啾隐私政策》。</b></span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span>在使用我们的各项产品和服务前，请您务必仔细阅读并透彻理解本规则，特别是以粗体</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span><span
>下划线标识的条款应重点阅读，在确认充分理解并同意全部条款后再开始使用。</span></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span>【儿童特别说明】</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span>如果您是不满</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>14</span></b><b><span
>周岁的儿童，我们特别提请您注意，请通知您的监护人共同阅读本规则及</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/privacy" target="_blank" ><span lang=EN-US><span
lang=EN-US>《蛮啾隐私政策》</span></span></a></span></b><b><span style='font-family:
宋体'>，并在您提交个人信息、使用蛮啾产品及服务之前，寻求并取得您的监护人的同意和指导。您点击同意本隐私政策，或者您使用</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span></b><b><span
>继续使用蛮啾产品及服务、提交个人信息，都表示您已获得您的监护人的许可，且您的监护人亦同意受本规则及</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/privacy" target="_blank" ><span lang=EN-US><span
lang=EN-US>《蛮啾隐私政策》</span></span></a></span></b><b><span style='font-family:
宋体'>的约束。</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span>【监护人特别说明】</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span>若您是儿童的监护人，我们特别提请您注意，请您要求您的被监护人在您的监护下共同阅读并接受本隐私政策，且应在您的同意和指导下提交个人信息、使用蛮啾产品及服务。如果您不同意本隐私政策的内容，您应要求您的被监护人立即停止使用蛮啾产品及服务。若您点击同意本隐私政策，或者您的被监护人使用或继续使用我们的服务，即表示您和您的被监护人同意受本隐私政策的约束。</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span>如果儿童或监护人对本隐私政策或与本隐私政策相关的事宜有任何意见或建议，可通过蛮啾官方公布的客服联系方式与我们取得联系，我们会给予您必要的帮助。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><b><span style='font-size:12.0pt;color:black;
background:#EEEEEE'>二、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;color:black;background:#EEEEEE'>我们如何收集和使用儿童个人信息</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.
</span><span>我们会严格遵守法律法规的规定，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则收集和使用儿童个人信息。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.
</span><span>在儿童使用产品或服务过程中，我们会收集相关信息，具体请查阅</span><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/protocol/privacy" target="_blank" ><span lang=EN-US><span
lang=EN-US>《蛮啾隐私政策》</span></span></a>“</span><span>一、</span><span
style='font-family:"Times New Roman",serif'> </span><span style='font-family:
宋体'>我们如何收集和使用个人信息</span><span lang=EN-US style='font-family:"Times New Roman",serif'>”</span><span
>相关内容，详细了解我们收集的其他儿童个人信息。如我们需要超出上述收集范围收集儿童的个人信息，我们将再次告知并征得监护人的同意。</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.
</span></b><b><span>根据相关法律法规规定，以下情形中收集儿童的信息无需征得儿童和</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span></b><b><span
>或监护人的授权同意：</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.1
</span></b><b><span>为订立和履行本隐私政策所必需；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.2
</span></b><b><span>为履行法定职责或法定义务所必需；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.3
</span></b><b><span>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.4
</span></b><b><span>为公共利益实施新闻报道、舆论监督行为，在合理的范围内收集和使用个人信息；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.5
</span></b><b><span>依照法律法规规定在合理范围内收集和使用儿童或监护人自行公开或其他已经合法公开的个人信息；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.6
</span></b><b><span>根据监护人的要求签订合同所必需的；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.7
</span></b><b><span>通过计算机信息系统自动留存处理信息且无法识别所留存处理的信息属于儿童个人信息的；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.8
</span></b><b><span>法律法规规定的其他情形。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><b><span style='font-size:12.0pt;color:black;
background:#EEEEEE'>三、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;color:black;background:#EEEEEE'>我们如何分享、转让、披露儿童个人信息</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1. </span></b><b><span
style='font-size:10.5pt;color:black'>信息的分享</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span
style='font-size:10.5pt;color:black'>我们遵照法律法规的规定，并严格遵守本规则及本隐私政策的约定，对儿童个人信息的分享进行严格限制。</span></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>2. </span></b><b><span
style='font-size:10.5pt;color:black'>信息的转让</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span
style='font-size:10.5pt;color:black'>随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方转让儿童的个人信息时，我们将进行安全评估，通过推送通知、公告等形式告知监护人相关情形，并要求新的持有儿童个人信息的公司、组织继续受本规则的约束，否则，我们将要求该公司、组织重新向监护人征求授权同意。</span></p>

<p class=police-line style='margin:0cm;background:white'><span
style='font-size:10.5pt;color:black'>在获得监护人的同意后，我们会向其他方转让儿童个人信息。</span></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3. </span></b><b><span
style='font-size:10.5pt;color:black'>信息的披露</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span
style='font-size:10.5pt;color:black'>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露儿童个人信息：</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3.1 </span><span
style='font-size:10.5pt;color:black'>根据儿童或监护人的需求，在监护人同意的披露方式下披露其所指定的信息；</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3.2 </span><span
style='font-size:10.5pt;color:black'>在法律法规、强制性的行政执法或司法要求必须提供儿童信息的情况下，我们可能会依据所要求的信息类型和披露方式披露儿童的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们将对所有披露请求进行慎重的审查，以确保其具备合法依据，且披露范围仅限于执法部门因特定调查目的且有合法权利获取的数据。</span></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4. </span></b><b><span
style='font-size:10.5pt;color:black'>分享、转让、披露信息时事先征得授权同意的例外</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span
style='font-size:10.5pt;color:black'>以下情形中，分享、转让、披露儿童的信息无需事先征得监护人的授权同意：</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.1 </span></b><b><span
style='font-size:10.5pt;color:black'>为履行法定职责或法定义务所必需；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.2 </span></b><b><span
style='font-size:10.5pt;color:black'>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.3 </span></b><b><span
style='font-size:10.5pt;color:black'>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内收集和使用个人信息；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.4 </span></b><b><span
style='font-size:10.5pt;color:black'>依照法律法规规定在合理范围内收集和使用儿童或监护人自行公开或其他已经合法公开的个人信息；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.5 </span></b><b><span
style='font-size:10.5pt;color:black'>根据监护人的要求签订合同所必需的；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.6 </span></b><b><span
style='font-size:10.5pt;color:black'>法律法规规定的其他情形。</span></b></p>

<p class=police-line style='margin:0cm;text-indent:21.4pt;background:white'><b><span
style='font-size:10.5pt;color:black'>根据法律规定，分享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外分享、转让及公开披露行为，对此类数据的保存及处理将无需另行向监护人通知或征得监护人的同意。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><b><span style='font-size:12.0pt;color:black;
background:#EEEEEE'>四、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;color:black;background:#EEEEEE'>我们如何存储和保护儿童个人信息</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1. </span><span
style='font-size:10.5pt;color:black'>我们仅在本规则所述目的所必需期间和法律法规要求的时限内保留儿童个人信息。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>2. </span><span
style='font-size:10.5pt;color:black'>我们按照法律法规规定，将在中华人民共和国境内收集到的儿童个人信息存储于中华人民共和国境内，并依法对这些信息进行严格保密。未经监护人的明示授权、法律法规的明确规定、行政执法或司法要求及</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>/</span><span style='font-size:10.5pt;color:black'>或相关主管机构的要求，我们不会将儿童个人信息转移出境。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3. </span><span
style='font-size:10.5pt;color:black'>为了保障儿童的个人信息安全，我们会在现有技术水平下采取合理可行的措施来保护儿童的个人信息。请查阅</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'><a href="/protocol/privacy" target="_blank" ><span lang=EN-US
><span lang=EN-US>《<span lang=EN-US>蛮啾<span lang=EN-US>隐私政策》</span></span></span></span></a></span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>“</span><span style='font-size:10.5pt;color:black'>四、我们如何存储和保护个人信息</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>”</span><span style='font-size:10.5pt;color:black'>章节，详细了解我们如何存储和保护儿童个人信息。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4. </span><b><span
style='font-size:10.5pt;color:black'>最后，监护人是唯一对其监护的儿童的账号和密码信息负有保密责任的人。在任何情况下，请监护人注意小心妥善保管该账号和密码信息，若因监护人自身原因导致儿童个人信息泄露或给监护人或儿童造成损失或其他不利影响，蛮啾对此不承担任何责任。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><b><span style='font-size:12.0pt;color:black;
background:#EEEEEE'>五、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;color:black;background:#EEEEEE'>您如何管理儿童个人信息</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span style='
color:black;background:white'>我们将严格遵照法律法规的规定，且严格遵守本规则及本隐私政策的约定，对儿童个人信息进行管理。如果监护人和儿童想访问、更正、删除儿童个人信息，可以</span><span
style='color:black'>查阅</span><span lang=EN-US style='font-family:
"Times New Roman",serif'><a href="/protocol/privacy" target="_blank" ><span lang=EN-US
><span lang=EN-US>《蛮啾隐私政策》</span></span></a></span><span
lang=EN-US style='font-family:"Times New Roman",serif;color:black'>“</span><span
style='color:black'>五、</span><span>您如何管理您的个人信息</span><span
lang=EN-US style='font-family:"Times New Roman",serif;color:black'>”</span><span
style='color:black'>章节<span style='background:white'>按照单项服务的具体指引进行，也可以通过我们提供的联系方式与我们取得联系。<b>我们会在收到核实反馈的问题后及时与监护人联系，并且在核实过程中，我们可能会要求监护人和</b></span></span><b><span
lang=EN-US style='font-family:"Times New Roman",serif;color:black;background:
white'>/</span></b><b><span style='color:black;background:white'>或儿童进行身份验证，以保障信息安全。</span></b><span
style='color:black;background:white'>除法律法规另有规定外，当监护人和儿童更正、删除儿童个人信息或申请注销账号时，我们可能不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></p>

<p class=MsoNormal><b><span style='font-size:12.0pt;color:black;
background:#EEEEEE'>六、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;color:black;background:#EEEEEE'>联系方式</span></b></p>

<p class=police-line style='margin:0cm;text-indent:21.0pt;background:white'><span
style='font-size:10.5pt;color:black'>如监护人和儿童有关于网络信息安全的投诉和举报，或对本规则及</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>/</span><span style='font-size:10.5pt;color:black'>或蛮啾对儿童个人信息保护的规则、措施的相关事宜有任何问题、意见或建议，或您对儿童使用我们的服务或其向我们提供的用户信息有任何疑问时，请随时与我们联系，可发送邮件至</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>cs@manjuu.com</span><span style='font-size:10.5pt;color:black'>或写信至以下地址：上海市徐汇区宜山路</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>700</span><span style='font-size:10.5pt;color:black'>号</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>B2</span><span style='font-size:10.5pt;color:black'>栋</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>1503</span><span style='font-size:10.5pt;color:black'>室上海蛮啾网络科技有限公司</span><span
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'> </span><span
style='font-size:10.5pt;color:black'>儿童个人信息保护专员（收）；邮编：</span><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>200233</span><span
style='font-size:10.5pt;color:black'>。</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span>我们将尽快审核所涉问题，并在验证您的用户身份后的</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>15</span><span
>个工作日或法律法规规定的期限内予以反馈。</span></p>
<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>
<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>
</div>

</body>

</html>`;

export default protectionContent;
